import { useCallback } from 'react'
import Swal from 'sweetalert2'
import { AssinaturaType, showAlertLoading, showError } from '../../../../../../_metronic/helpers'
import { useCertificado } from '../../../../../helpers/hooks/useCertificado'
import { getAtendimentoById } from '../../../atendimento/core/_requests'
import { signAvaliacao } from '../../../avaliacoes/avaliacoes-pendentes-list/core/_requests'
import { pareceresParaAssinar } from '../../../pareceres/pareceres-list/core/formulariosInterconsulta'

/**
 * Assina os pareceres respondidos e ainda não assinados, lidos do atendimento atual. Com o
 * atendimento finalizado, a assinatura conclui a interconsulta no backend e avisa o solicitante.
 */
export const assinarPareceresPendentes = async (atendimentoId: number, tipo: AssinaturaType) => {
  const atendimento = await getAtendimentoById(atendimentoId)
  await Promise.all(
    pareceresParaAssinar(atendimento.formularios).map((formulario) =>
      signAvaliacao({
        atendimento: atendimentoId,
        formularioAtendimento: Number(formulario.id),
        tipo,
      })
    )
  )
}

/**
 * Assinatura do parecer de uma interconsulta já finalizada (a assinatura falhou ou ficou para
 * depois), sem reabrir o atendimento. Devolve `true` se assinou; erro já é mostrado aqui, e
 * certificado cancelado devolve `false` sem alerta.
 */
export const useAssinarParecer = () => {
  const { ensurePassword } = useCertificado()

  return useCallback(
    async (atendimentoId: number): Promise<boolean> => {
      try {
        const certificado = await ensurePassword()
        if (!certificado.ok || !certificado.tipo) return false

        showAlertLoading()
        await assinarPareceresPendentes(atendimentoId, certificado.tipo)
        Swal.close()
        return true
      } catch (error) {
        await showError(error)
        return false
      }
    },
    [ensurePassword]
  )
}
